export const SIZES = Object.freeze({
  LG: 'lg',
  SM: 'sm',
});

export const CUSTOM_INPUT = Object.freeze({
  [SIZES.LG]: {
    fontSize: 'meta',
    icon: {
      width: '16px',
      height: '16px',
    },
    spacers: ['md', 'sm'],
  },
  [SIZES.SM]: {
    fontSize: 'small',
    icon: {
      width: '12px',
      height: '14px',
    },
    spacers: ['md'],
  },
});
